import { FC } from 'react';
import bitsLogo from 'assets/bitsLogo.png';

const BitsLogo: FC = () => (
  <img src={bitsLogo} width={32} height={32} alt="bits of stock" />
);

export default BitsLogo;
